const deletetask = async ({ email, taskId }) => {
  try {
    const response = await fetch(
      `https://taskbackend-4o2x.onrender.com/deleteTask/${email}/tasks/${taskId}`,
      {
        method: 'DELETE',
      },
    )
    if (!response.ok) {
      throw new Error('Failed to delete task')
    }
    return await response.json()
  } catch (error) {
    console.error('Error deleting task:', error)
    throw error
  }
}

export default deletetask
